"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AdpIntegrationModel () {
        return AdpIntegrationModel;
    },
    get BambooHrIntegrationModel () {
        return BambooHrIntegrationModel;
    },
    get INTEGRATION_NAMES () {
        return INTEGRATION_NAMES;
    },
    get IntegrationModel () {
        return IntegrationModel;
    },
    get IntegrationName () {
        return IntegrationName;
    },
    get IntegrationSyncType () {
        return IntegrationSyncType;
    },
    get IntegrationType () {
        return IntegrationType;
    },
    get IntegrationWorkerModel () {
        return IntegrationWorkerModel;
    },
    get IntegrationWorkerStatus () {
        return IntegrationWorkerStatus;
    },
    get NetchexIntegrationModel () {
        return NetchexIntegrationModel;
    },
    get SftpIntegrationModel () {
        return SftpIntegrationModel;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const _fields = require("../fields");
const _integrationemployeerecordmappingsettings = require("./integration-employee-record-mapping-settings");
const INTEGRATION_NAMES = [
    "ukg-pro",
    "netchex",
    "bamboohr",
    "rippling",
    "adp-vantage",
    "adp-wfn",
    "gusto"
];
const IntegrationName = _zod.z.enum(INTEGRATION_NAMES);
const IntegrationType = _zod.z.enum([
    "integration-sync",
    "sftp-sync",
    "connect-workers",
    "csv-upload",
    "csv",
    "public-api"
]);
const IntegrationWorkerStatus = _zod.z.enum([
    "pending",
    "connected",
    "not-connected"
]);
const IntegrationSyncType = _zod.z.enum([
    "pull",
    "not-connected"
]);
const IntegrationModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    access_token: _zod.z.string().optional(),
    associate_id: _zod.z.string().optional(),
    available_fields: _zod.z.array(_zod.z.object({
        fieldName: _zod.z.string(),
        fieldID: _zod.z.string(),
        fieldType: _zod.z.string()
    })).optional(),
    client_id: _zod.z.string().optional(),
    client_secret: _zod.z.string().optional(),
    company: _zod.z.instanceof(_bson.ObjectId),
    credentials_status: _zod.z.string().optional(),
    deactivate_users_when_not_present: _zod.z.boolean().optional(),
    deleted: _zod.z.boolean().optional(),
    external_company_id: _zod.z.string().optional(),
    integration_type: IntegrationName,
    last_employee_index_fetched: _zod.z.number().optional(),
    last_fetch: _zod.z.date().optional(),
    organization: _zod.z.string().optional(),
    organization_id: _zod.z.string().optional(),
    originator_id: _zod.z.string().optional(),
    primary_user_id: _zod.z.string().optional(),
    refresh_token: _zod.z.string().optional(),
    synced_fields: _zod.z.array(_zod.z.object({
        internal_field_name: _zod.z.string(),
        external_field_name: _zod.z.string(),
        external_field_id: _zod.z.string(),
        sync_type: IntegrationSyncType,
        internal_field_id: _zod.z.instanceof(_bson.ObjectId),
        internal_field_type: _fields.CustomFieldTypes.or(_zod.z.literal(""))
    })),
    token: _zod.z.string().optional(),
    ukg_pro_iv: _zod.z.string().optional(),
    ukg_pro_api_key: _zod.z.string().optional(),
    ukg_pro_base_url: _zod.z.string().optional(),
    ukg_pro_password: _zod.z.string().optional(),
    ukg_pro_username: _zod.z.string().optional(),
    ukg_pro_company_codes: _zod.z.array(_zod.z.string()).optional(),
    walkthrough_finished: _zod.z.boolean().optional(),
    current_integration_log: _zod.z.instanceof(_bson.ObjectId).nullable().optional(),
    permission_scope_version: _zod.z.number().positive().optional(),
    employee_record_mapping_settings: _integrationemployeerecordmappingsettings.IntegrationEmployeeRecordMappingSettings.optional()
});
const IntegrationWorkerModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    company: _zod.z.instanceof(_bson.ObjectId),
    created_at: _zod.z.date(),
    data: _zod.z.object({}).catchall(_zod.z.unknown()),
    external_company_id: _zod.z.string(),
    external_id: _zod.z.string(),
    integration: _zod.z.instanceof(_bson.ObjectId),
    last_updated: _zod.z.date(),
    performyard_user_id: _zod.z.instanceof(_bson.ObjectId).optional(),
    status: IntegrationWorkerStatus
});
const SftpIntegrationModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    company_id: _zod.z.instanceof(_bson.ObjectId),
    created_at: _zod.z.date(),
    deactivate_user_on_missing: _zod.z.boolean(),
    deleted_at: _zod.z.date().or(_zod.z.null()).optional(),
    emails: _zod.z.array(_zod.z.string()),
    field_mapping_list: _zod.z.array(_zod.z.object({
        csv_column_name: _zod.z.string(),
        performyard_custom_field_name: _zod.z.string()
    })),
    field_mapping_object: _zod.z.object({}).optional(),
    integration_type: _zod.z.literal("sftp-sync"),
    is_testing: _zod.z.boolean().optional(),
    last_sync_date: _zod.z.date().or(_zod.z.null()).optional(),
    name: _zod.z.string(),
    primary_user_id: _zod.z.string().optional(),
    secondary_user_id: _zod.z.string().optional(),
    status: _zod.z.enum([
        "enabled",
        "disabled"
    ]),
    updated_at: _zod.z.date()
});
const NetchexIntegrationModel = IntegrationModel.pick({
    _id: true,
    available_fields: true,
    client_id: true,
    client_secret: true,
    company: true,
    last_fetch: true,
    synced_fields: true,
    token: true,
    walkthrough_finished: true
}).extend({
    integration_type: _zod.z.literal("netchex")
});
const BambooHrIntegrationModel = IntegrationModel.pick({
    _id: true,
    available_fields: true,
    client_id: true,
    client_secret: true,
    company: true,
    deactivate_users_when_not_present: true,
    last_fetch: true,
    organization: true,
    synced_fields: true,
    token: true,
    walkthrough_finished: true
}).extend({
    integration_type: _zod.z.literal("bamboohr")
});
const AdpIntegrationModel = IntegrationModel.pick({
    _id: true,
    associate_id: true,
    available_fields: true,
    client_id: true,
    client_secret: true,
    company: true,
    current_integration_log: true,
    deactivate_users_when_not_present: true,
    last_employee_index_fetched: true,
    last_fetch: true,
    organization_id: true,
    synced_fields: true,
    token: true,
    walkthrough_finished: true
}).extend({
    integration_type: _zod.z.union([
        _zod.z.literal("adp-vantage"),
        _zod.z.literal("adp-wfn")
    ])
});
